/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // Combine date and time fields for contact form datetime inputs
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.form__item--datetime').forEach(wrapper => {
      const dateInput = wrapper.querySelector('[data-datetime-date]');
      const timeInput = wrapper.querySelector('[data-datetime-time]');
      const hiddenInput = wrapper.querySelector('input[type="hidden"]');

      if (!dateInput || !timeInput || !hiddenInput) return;

      const updateValue = () => {
        if (dateInput.value && timeInput.value) {
          // Parse yyyy-mm-dd format and convert to dd/mm/yyyy
          const [year, month, day] = dateInput.value.split('-');
          const formattedDate = `${day}/${month}/${year}`;
          hiddenInput.value = `${formattedDate} ${timeInput.value}`;
        }
      };

      dateInput.addEventListener('change', updateValue);
      timeInput.addEventListener('change', updateValue);
    });
  });

  // Ensure collection promo videos autoplay after Ajaxinate injects content
  (function() {
    function playPromoVideos(scope) {
      (scope || document).querySelectorAll('.collection-promo__video video').forEach(function(video) {
        if (video.paused) {
          video.muted = true;
          video.play().catch(function() {});
        }
      });
    }

    function observeAjaxinateContainers() {
      document.querySelectorAll('#AjaxinateLoop').forEach(function(container) {
        var observer = new MutationObserver(function() {
          playPromoVideos(container);
        });
        observer.observe(container, { childList: true, subtree: true });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() {
        playPromoVideos();
        observeAjaxinateContainers();
      });
    } else {
      playPromoVideos();
      observeAjaxinateContainers();
    }
  })();

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
